import type { CompanyProfile } from '@coreledger/shared-types';
import { API_BASE, ApiError, api } from './client';

export interface AppSettings {
  currency: string;
  dateFormat: string;
  defaultTaxType: 'cgst_sgst' | 'igst';
  defaultDocType: string;
  termsAndConditions?: string;
  invoiceFooterNote?: string;
  enableStock: boolean;
  invoiceFormat: string;
}

export interface InvoiceSequenceDto {
  docType: string;
  prefix: string;
  lastNumber: number;
  fyStart: number;
}

export const companyApi = {
  get: () => api.get<CompanyProfile>('/company/profile'),
  save: (data: CompanyProfile) => api.put<CompanyProfile>('/company/profile', data),
  deleteProfile: () => api.delete<void>('/company/profile'),
  uploadLogo: async (file: File): Promise<{ logoPath: string }> => {
    const token = sessionStorage.getItem('cl_token');
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch(`${API_BASE}/company/logo`, { method: 'POST', headers: token ? { Authorization: `Bearer ${token}` } : {}, body: fd });
    if (!res.ok) {
      const text = await res.text().catch(() => '');
      const body = text ? (JSON.parse(text) as { message?: string }) : {};
      throw new ApiError(res.status, body.message ?? 'Logo upload failed');
    }
    return res.json() as Promise<{ logoPath: string }>;
  },
  getSettings: () => api.get<AppSettings>('/company/settings'),
  saveSettings: (data: Partial<AppSettings>) => api.put<AppSettings>('/company/settings', data),
  getSequences: () => api.get<InvoiceSequenceDto[]>('/company/sequences'),
  updateSequence: (docType: string, data: { prefix?: string; lastNumber?: number }) =>
    api.patch<InvoiceSequenceDto>('/company/sequences/' + docType, data),
};
